<div #htmlBox class="html-more-wrapper break-word" [innerHTML]="htmlValue"
     [ngClass]="{'collapsed': collapsed, 'short': height === HeightMultiplierEnum.Short, 'high': height === HeightMultiplierEnum.High}" ></div>
<ng-container *ngIf="getHeight > ((utilService.getGridSize * height) - 1)">
  <div class="blur-layer" *ngIf="collapsed"></div>
  <a class="link body-3 bold html-link" (click)="$event.stopPropagation(); collapsed = !collapsed;">
    <span>{{ (collapsed ? 'general.api_show_more' : 'general.api_show_less') | translate }}</span>
  </a>
</ng-container>
